var map = {
	"./Coffee_at_home_credit_Getty_Images_desktop.jpg": 529,
	"./Coffee_at_home_credit_Getty_Images_mobile.jpg": 530,
	"./Coffee_at_home_credit_Getty_Images_tablet.jpg": 531,
	"./Coffee_in_Cambodia_credit_Getty_Images_desktop.jpg": 532,
	"./Coffee_in_Cambodia_credit_Getty_Images_mobile.jpg": 533,
	"./Coffee_in_Cambodia_credit_Getty_Images_tablet.jpg": 534,
	"./Getty_Images_1145406500_desktop.jpg": 535,
	"./Getty_Images_1145406500_mobile.jpg": 536,
	"./Getty_Images_1145406500_tablet.jpg": 537,
	"./Getty_Images_1188457330_desktop.jpg": 538,
	"./Getty_Images_1188457330_mobile.jpg": 539,
	"./Getty_Images_1188457330_tablet.jpg": 540,
	"./Getty_Images_160375427_desktop.jpg": 541,
	"./Getty_Images_160375427_mobile.jpg": 542,
	"./Getty_Images_160375427_tablet.jpg": 543,
	"./Hand-Gel-Belgium-Getty_desktop.jpg": 544,
	"./Hand-Gel-Belgium-Getty_mobile.jpg": 545,
	"./Hand-Gel-Belgium-Getty_tablet.jpg": 546,
	"./Simon_Lycett_getty_desktop.jpg": 547,
	"./Simon_Lycett_getty_mobile.jpg": 548,
	"./Simon_Lycett_getty_tablet.jpg": 549,
	"./Spices-stall-India_desktop.jpg": 550,
	"./Spices-stall-India_mobile.jpg": 551,
	"./Spices-stall-India_tablet.jpg": 552,
	"./Takeaway_coffee_credit_Getty_Images_desktop.jpg": 553,
	"./Takeaway_coffee_credit_Getty_Images_mobile.jpg": 554,
	"./Takeaway_coffee_credit_Getty_Images_tablet.jpg": 555,
	"./barcelona_getty_desktop.jpg": 556,
	"./barcelona_getty_mobile.jpg": 557,
	"./barcelona_getty_tablet.jpg": 558,
	"./brazil_covid_art_crafts_getty_desktop.jpg": 559,
	"./brazil_covid_art_crafts_getty_mobile.jpg": 560,
	"./brazil_covid_art_crafts_getty_tablet.jpg": 561,
	"./china_paper_cups_getty_desktop.jpg": 562,
	"./china_paper_cups_getty_mobile.jpg": 563,
	"./china_paper_cups_getty_tablet.jpg": 564,
	"./coffee_image_card_beans_in_hands_desktop.jpg": 565,
	"./coffee_image_card_beans_in_hands_mobile.jpg": 566,
	"./coffee_image_card_beans_in_hands_tablet.jpg": 567,
	"./coffee_image_card_woman_on_shop_desktop.jpg": 568,
	"./coffee_image_card_woman_on_shop_mobile.jpg": 569,
	"./coffee_image_card_woman_on_shop_tablet.jpg": 570,
	"./columbia_getty_desktop.jpg": 571,
	"./columbia_getty_mobile.jpg": 572,
	"./columbia_getty_tablet.jpg": 573,
	"./flowers_yorkshire_getty_desktop.jpg": 574,
	"./flowers_yorkshire_getty_mobile.jpg": 575,
	"./flowers_yorkshire_getty_tablet.jpg": 576,
	"./full_width_version_desktop.jpg": 577,
	"./full_width_version_mobile.jpg": 578,
	"./full_width_version_tablet.jpg": 579,
	"./getty_Images_1204596112_desktop.jpg": 580,
	"./getty_Images_1204596112_mobile.jpg": 581,
	"./getty_Images_1204596112_tablet.jpg": 582,
	"./handbags_4_getty_desktop.jpg": 583,
	"./handbags_4_getty_mobile.jpg": 584,
	"./handbags_4_getty_tablet.jpg": 585,
	"./handbags_getty_desktop.jpg": 586,
	"./handbags_getty_mobile.jpg": 587,
	"./handbags_getty_tablet.jpg": 588,
	"./handbags_mipel_desktop.jpg": 589,
	"./handbags_mipel_mobile.jpg": 590,
	"./handbags_mipel_tablet.jpg": 591,
	"./hero_kenia_getty_desktop.jpg": 592,
	"./hero_kenia_getty_mobile.jpg": 593,
	"./hero_kenia_getty_tablet.jpg": 594,
	"./italy_paper_mill_getty_desktop.jpg": 595,
	"./italy_paper_mill_getty_mobile.jpg": 596,
	"./italy_paper_mill_getty_tablet.jpg": 597,
	"./last_getty_desktop.jpg": 598,
	"./last_getty_mobile.jpg": 599,
	"./last_getty_tablet.jpg": 600,
	"./london_getty_desktop.jpg": 601,
	"./london_getty_mobile.jpg": 602,
	"./london_getty_mobile_tablet.jpg": 603,
	"./man_barrels_getty_desktop.jpg": 604,
	"./man_barrels_getty_mobile.jpg": 605,
	"./man_barrels_getty_tablet.jpg": 606,
	"./paper_covid_tests_getty_desktop.jpg": 607,
	"./paper_covid_tests_getty_mobile.jpg": 608,
	"./paper_covid_tests_getty_tablet.jpg": 609,
	"./paper_facory_getty_desktop.jpg": 610,
	"./paper_facory_getty_mobile.jpg": 611,
	"./paper_facory_getty_tablet.jpg": 612,
	"./paris_florist_getty_desktop.jpg": 613,
	"./paris_florist_getty_mobile.jpg": 614,
	"./paris_florist_getty_tablet.jpg": 615,
	"./protection_paper_getty_desktop.jpg": 616,
	"./protection_paper_getty_mobile.jpg": 617,
	"./protection_paper_getty_tablet.jpg": 618,
	"./semiconductors_2_desktop.jpg": 619,
	"./semiconductors_2_mobile.jpg": 620,
	"./semiconductors_2_tablet.jpg": 621,
	"./semiconductors_5_desktop.jpg": 622,
	"./semiconductors_5_mobile.jpg": 623,
	"./semiconductors_5_tablet.jpg": 624,
	"./shop_getty_desktop.jpg": 625,
	"./shop_getty_mobile.jpg": 626,
	"./shop_getty_tablet.jpg": 627,
	"./spices_over_food_getty_desktop.jpg": 628,
	"./spices_over_food_getty_mobile.jpg": 629,
	"./spices_over_food_getty_tablet.jpg": 630,
	"./toilet_paper_getty_desktop.jpg": 631,
	"./toilet_paper_getty_mobile.jpg": 632,
	"./toilet_paper_getty_tablet.jpg": 633,
	"./turmeric_getty_desktop.jpg": 634,
	"./turmeric_getty_mobile.jpg": 635,
	"./turmeric_getty_tablet.jpg": 636,
	"./vertical_option_desktop.jpg": 637,
	"./vertical_option_mobile.jpg": 638,
	"./vertical_option_tablet.jpg": 639,
	"./whisky_distillery_desktop.jpg": 640,
	"./whisky_distillery_mobile.jpg": 641,
	"./whisky_distillery_tablet.jpg": 642
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 528;